<template>
  <fragment>
    <v-row>
      <v-col cols="12" sm="6">
        <v-btn
          width="100%"
          class="rounded-lg"
          color="white"
          @click="openDescriptionModal"
          hide-details
        >
          <v-icon left v-if="descriptionIsNotEmpty" color="green">
            mdi-text-box-check-outline
          </v-icon>
          <v-icon left v-else>mdi-text-box-remove-outline</v-icon>
          {{ $t("events.event-config.insert-description-here") }}
        </v-btn>
      </v-col>
      <v-col cols="12" sm="6">
        <BaseSelect
          :label="$t('events.status')"
          :placeholder="$t('events.select-status')"
          required
          item-text="value"
          item-value="key"
          :items="$produtos_gerenciar.status_produtos"
          :rules="[rules.required]"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.status"
        />
      </v-col>
    </v-row>
    <v-row class="mb-3">
      <v-col cols="12" sm="6">
        <BaseSelect
          :label="$t('events.category')"
          :placeholder="$t('events.select-category')"
          required
          item-text="descricao"
          item-value="idcategoria"
          :items="$produtos_gerenciar.categorias_produtos"
          :rules="[rules.required]"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.categoria"
        />
      </v-col>
      <v-col>
        <BaseMoneyField
          required
          :label="$t('events.event-config.price')"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.preco"
        />
      </v-col>
    </v-row>
    <label style="font-weight: 600; font-size: 14px">Endereço do evento</label>
    <v-divider class="mb-5"></v-divider>
    <v-row>
      <v-col cols="12" sm="6">
        <BaseTextField
          :label="$t('events.event-config.event-location')"
          :placeholder="$t('events.event-config.insert-event-location')"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.endereco"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <BaseAutocomplete
          :label="$t('events.event-config.country')"
          :placeholder="$t('events.event-config.select-country')"
          item-text="dsc_lang"
          item-value="iso_full"
          needSelection
          autocomplete="null"
          auto-select-first
          :loading="$config.loading_paises"
          :items="$config.paises.result"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.pais"
        >
          <template v-slot:selection="{ item }">
            <v-chip small v-bind="item" :input-value="item">
              <template v-if="item ? (paises = item) : null">
                {{ item.dsc_lang }}
              </template>
            </v-chip>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-content v-if="item">
              <v-list-item-title v-text="item.dsc_lang"></v-list-item-title>
            </v-list-item-content>
          </template>
        </BaseAutocomplete>
      </v-col>
    </v-row>
    <v-row class="mb-3">
      <v-col cols="12" sm="6">
        <BaseAutocomplete
          :label="$t('events.event-config.state')"
          :placeholder="$t('events.event-config.select-state')"
          item-text="dsc_lang"
          item-value="iso_full"
          needSelection
          autocomplete="null"
          auto-select-first
          :loading="$config.loading_estados"
          :items="$config.estados.result"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.estado"
        >
          <template template v-slot:selection="{ item }">
            <v-chip small v-bind="item" :input-value="item.selected">
              <template v-if="item ? (estados = item) : null">
                {{ item.dsc_lang }}
              </template>
            </v-chip>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-content v-if="item">
              <v-list-item-title v-text="item.dsc_lang"></v-list-item-title>
            </v-list-item-content>
          </template>
        </BaseAutocomplete>
      </v-col>
      <v-col cols="12" sm="6">
        <BaseAutocomplete
          :label="$t('events.event-config.city')"
          :placeholder="$t('events.event-config.select-city')"
          item-text="dsc_lang"
          item-value="dsc_lang"
          :loading="$config.loading_cidades"
          :items="$config.cidades.result"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.cidade"
        >
        </BaseAutocomplete>
      </v-col>
      <v-col cols="12" sm="6" v-if="isAdmin">
        <v-checkbox
          :label="$t('events.event-config.show-accomodation-map')"
          class="my-0"
          v-model="
            $produtos_gerenciar.cadastro.dados_cadastrais.mapa_hospedagem
          "
        ></v-checkbox>
      </v-col>
    </v-row>
    <label style="font-weight: 600; font-size: 14px">
      {{ $t("events.event-config.complementary-info") }}
    </label>
    <v-divider class="mb-5"></v-divider>
    <v-row>
      <v-col cols="12" sm="6">
        <BaseSelect
          label="Tag"
          item-text="key"
          item-value="value"
          :placeholder="$t('events.event-config.select-tags')"
          :items="tags"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.tags"
        />
      </v-col>
      <v-col cols="12" sm="6" v-if="isAdmin">
        <v-checkbox
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.destaque"
          :label="$t('events.event-config.highlight-product')"
          class="rounded-lg pa-2 mt-0"
          style="border: 1px solid rgb(0 0 0 / 42%)"
          active-class="active-class"
          hide-details
        >
        </v-checkbox>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <BaseTextField
          hide-details
          :label="$t('events.event-config.limit-ticket-per-consumer')"
          placeholder="Ex: 5"
          type="number"
          min="1"
          v-model="
            $produtos_gerenciar.cadastro.dados_cadastrais.limite_venda_cpf
          "
        />
      </v-col>
    </v-row>
    <DescriptionProduct />
  </fragment>
</template>
<script>
import mixins from "@/mixins";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseMoneyField from "@/components/forms/BaseMoneyField.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import DescriptionProduct from "@/components/produtos/gerenciar/DescriptionProduct.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
import { mapGetters } from "vuex";

const { formRules, products } = mixins;

export default {
  name: "RechargeProduct",
  mixins: [formRules, products],
  data: () => ({
    paises: [],
    estados: [],
    cidades: [],
  }),
  components: {
    BaseSelect,
    BaseMoneyField,
    BaseTextField,
    DescriptionProduct,
    BaseAutocomplete,
  },
  methods: {
    openDescriptionModal() {
      this.$produtos_gerenciar.descriptionModal = true;
    },
  },
  watch: {
    paises(e) {
      this.$config.getEstados(e.id);
    },
    estados(e) {
      this.$config.getCidades(e.id);
    },
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    descriptionIsNotEmpty() {
      return (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.descritivo !== ""
      );
    },
    limitedTickets() {
      return this.$produtos_gerenciar.cadastro.dados_cadastrais
        .limitarIngressos;
    },
    manageStock() {
      return (
        this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos
          .length === 0 &&
        this.$produtos_gerenciar.cadastro.dados_cadastrais.gerenciar_estoque ===
          1
      );
    },
  },
  mounted() {
    this.$config.getPaises();
    if (this.$produtos_gerenciar.cadastro.dados_cadastrais.pais) {
      this.pais = this.$produtos_gerenciar.cadastro.dados_cadastrais.pais;
    }

    if (this.$produtos_gerenciar.cadastro.dados_cadastrais.estado) {
      this.estado = this.$produtos_gerenciar.cadastro.dados_cadastrais.estado;
    }
    if (this.$produtos_gerenciar.cadastro.dados_cadastrais.cidade) {
      this.cidade = this.$produtos_gerenciar.cadastro.dados_cadastrais.cidade;
    }
  },
};
</script>
<style>
.active-class {
  background-color: #e6f7ff !important;
  border-color: #91d5ff !important;
  color: #1890ff !important;
}
</style>
